export default {"src":"/_next/static/media/STWD.31cd551c.svg","height":18,"width":18};